import React, { createContext, useContext, ReactNode } from 'react';
import { useNotifications } from '../hooks/useNotifications';

// Single shared notifications instance. Previously useNotifications() was called
// independently by GlobalLayout, BottomNavigation, NotificationCenter and
// Friends — each running its OWN 30s poll and push-revalidation, so the app
// hit /notifications/unread-count 3-4x on load and every ~10s thereafter.
// This provider calls the hook once and shares the result.

type NotificationsValue = ReturnType<typeof useNotifications>;

const NotificationsContext = createContext<NotificationsValue | null>(null);

export const NotificationsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const value = useNotifications();
  return (
    <NotificationsContext.Provider value={value}>
      {children}
    </NotificationsContext.Provider>
  );
};

export const useNotificationsContext = (): NotificationsValue => {
  const ctx = useContext(NotificationsContext);
  if (!ctx) {
    throw new Error('useNotificationsContext must be used within a NotificationsProvider');
  }
  return ctx;
};
